import { render } from "./QuoteAdditionalInsurance.vue?vue&type=template&id=e3fb3468&scoped=true"
import script from "./QuoteAdditionalInsurance.vue?vue&type=script&lang=js"
export * from "./QuoteAdditionalInsurance.vue?vue&type=script&lang=js"

import "./QuoteAdditionalInsurance.vue?vue&type=style&index=0&id=e3fb3468&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3fb3468"]])

export default __exports__